/**
 * Saleor JWT `iss` equals the GraphQL endpoint URL string exactly.
 * A trailing-slash mismatch (`/graphql` vs `/graphql/`) causes:
 * "Token's `iss` and request URL do not match" — no Authorization header on client requests.
 *
 * Use the same normalization for `NEXT_PUBLIC_SALEOR_API_URL`, `SALEOR_API_URL`, and auth-sdk.
 */
export function normalizeSaleorGraphqlUrl(url: string): string {
	const trimmed = url.trim();
	if (!trimmed) return trimmed;
	const withoutTrailingSlashes = trimmed.replace(/\/+$/, "");
	return `${withoutTrailingSlashes}/`;
}
